// notificacion-toast.util.ts
import Swal from 'sweetalert2';
import { NotificacionesHeaderService } from '@app/services/notificaciones/notificaciones-header.service';

export function showIncomingNotificationToast(
  payload: any,
  headerSvc: NotificacionesHeaderService,
  onMarked?: () => void
) {
  const n   = payload?.notification || {};
  const id  = payload?.notificationId ?? n?.id;
  const ttl = n?.title ?? 'Notificación';
  const msg = n?.message ?? '';
  const who = n?.senderName ? `<div class="notif-who">${n.senderName}</div>` : '';

  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'info',
    title: ttl,
    html: `
      ${who}
      <div class="notif-msg">${msg}</div>
    `,
    showConfirmButton: true,
    confirmButtonText: 'Marcar como leído',
    showCancelButton: true,
    cancelButtonText: 'Cerrar',
    showCloseButton: true,
    timer: undefined,
    allowOutsideClick: false,
    allowEscapeKey: true,
    customClass: {
      popup: 'notif-toast',
      title: 'notif-title',
      htmlContainer: 'notif-body',
      actions: 'notif-actions',
      closeButton: 'notif-close bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 rounded-full p-1 transition-colors duration-200'
    },
    didOpen: (el) => {
      // quitar foco automático del botón de confirm para evitar ENTER accidental
      const btn = el.querySelector<HTMLButtonElement>('.swal2-confirm');
      btn?.blur();
      
      // Aplicar clases adicionales de Tailwind al botón de cerrar
      const closeBtn = el.querySelector<HTMLButtonElement>('.swal2-close');
      if (closeBtn) {
        // Opción 1: Clases directamente en el elemento
        closeBtn.className += ' w-8 h-8 flex items-center justify-center shadow-sm border border-gray-200';
        
        // Opción 2: Reemplazar completamente las clases (más control)
        // closeBtn.className = 'swal2-close w-8 h-8 bg-red-50 hover:bg-red-100 text-red-500 hover:text-red-700 rounded-full flex items-center justify-center transition-all duration-200 border border-red-200 hover:border-red-300';
        
        // Opción 3: Personalizar el ícono de cerrar
        closeBtn.innerHTML = '×'; // o usar un SVG personalizado
        closeBtn.style.fontSize = '18px';
        closeBtn.style.fontWeight = 'bold';
      }
    }
  }).then(async (res) => {
    if (res.isConfirmed && id) {
      try {
        const ok = await headerSvc.marcarComoLeida(id).toPromise();
        if (ok) {
          onMarked?.();
        }
      } catch (_) { /* noop */ }
    }
  });
}